import {
  type DataType,
  type EventParams,
  type GA4Event,
  dataLayerPush,
} from '@/libs/ga4';

export function sendEvent<E extends GA4Event>(
  eventName: E,
  data: DataType[E],
  eventParams?: EventParams,
) {
  const { items, ...rest } = data;

  if (items && items.length > 0) {
    dataLayerPush({
      event: eventName,
      ecommerce: { items, ...rest },
      ...eventParams,
    });
  } else {
    dataLayerPush({
      event: eventName,
      ...eventParams,
    });
  }
}
